import { Validators } from "@angular/forms"
import { IFormKey } from "src/app/modules/shared/models/forms"
import { IObjectKey } from "src/app/modules/shared/models/objects"

export const ndg_variation_form_template = {
    ndg: ''
}

export const ndg_variation_form_validators = {
    ndg: [Validators.required]
}

export const ndg_variation_form_keys: IFormKey[] = [
    {
        id: 'ndg-field',
        label: 'Soggetto richiedente',
        controlName: 'ndg',
        css: 'col-6',
        type: 'SELECT',
        readonly: false,
        options: []
    }
]

export interface IAnagrafica {
    "ns2:codiceCollegamento": string,
    "ns2:ndgLegante": string,
    "ns2:dataCollegamento": string,
    "ns2:percLegato": string,
    "ns2:dettaglioAnagrafico": IDettaglioAnagrafico;
}

export interface IDettaglioAnagrafico {
    "ns2:ndg": string;
    "ns2:bancaRicevente": string;
    "ns2:cognome": string;
    "ns2:nome": string;
    "ns2:sesso": string;
    "ns2:dataNascita": string;
    "ns2:comuneNascita": string;
    "ns2:provinciaNascita": string;
    "ns2:codiceNazioneNascita": string;
    "ns2:statoCivile": string;
    "ns2:naturaGiuridica": string;
    "ns2:regimePatrimoniale": string;
    "ns2:indirizzoSedeLegale": string;
    "ns2:capSedeLegale": string;
    "ns2:comuneSedeLegale": string;
    "ns2:provinciaSedeLegale": string;
    "ns2:codiceNazioneSedeLegale": string;
    "ns2:numeroProvinciaBankitalia": string;
    "ns2:cabBankitalia": string;
    "ns2:cinBankitalia": string;
    "ns2:tipologiaCliente": string;
    "ns2:filialeAttribuzione": string;
    "ns2:sae": string;
    "ns2:rae": string;
    "ns2:ciae": string;
    "ns2:codiceFiscale": string;
    "ns2:partitaIva": string;
    "ns2:intestazioneRidotta": string;
    "ns2:sottointestazioneDomicilioFiscale": string;
    "ns2:indirizzoDomicilioFiscale": string;
    "ns2:capDomicilioFiscale": string;
    "ns2:localitaDomicilioFiscale": string;
    "ns2:codiceNazioneDomicilioFiscale": string;
    "ns2:nazioneDomicilioFiscale": string;
    "ns2:tipoSpedizione": string;
    "ns2:dataCensimentoNdg": string;
    "ns2:stato": string;
    "ns2:ragioneSocialeRiga1": string;
    "ns2:ragioneSocialeRiga2": string;
    "ns2:ragioneSocialeRiga3": string;
    "ns2:provinciaIscrizioneCameraCommercio": string;
    "ns2:provinciaIscrizioneTribunale": string;
    "ns2:numeroIscrizioneArtigianato": string;
    "ns2:datiDocumento": {
        "ns2:tipo": string;
        "ns2:decodifica": string;
        "ns2:numero": string;
        "ns2:dataEmissione": string;
        "ns2:luogoEmissione": string;
        "ns2:autoritaEmissione": string;
        "ns2:CABLuogo": string;
        "ns2:dataScadenza": string;
    };
    "ns2:codiceAteco": string;
    "ns2:telefono": {
        "ns2:prefissoTel1": string;
        "ns2:prefissoTel2": string;
        "ns2:numero1": string;
        "ns2:numero2": string;
    };
    "ns2:codiceUIC": string;
    "ns2:codiceCentraleRischi": string;
    "ns2:dataUltimaSegnalazioneCentraleRischi": string;
    "ns2:email": string;
    "ns2:flagConsenso": string;
    "ns2:codicePrimaCittadinanza": string;
    "ns2:codiceSecondaCittadinanza": string;
    "ns2:taxIdentificationNumber": string;
    "ns2:codiceNazioneTIN": string;
    "ns2:taxIdentificationNumber2": string;
    "ns2:codiceNazioneTIN2": string;
    "ns2:taxIdentificationNumber3": string;
    "ns2:codiceNazioneTIN3": string;
    "ns2:nazioneAmministrazione": string;
    "ns2:nazioneCostituzione": string;
    "ns2:numeroIscrizioneCameraCommercio": string;
    "ns2:numeroIscrizioneTribunale": string;
    "ns2:cabComuneNascita": string;
    "ns2:cinCabComuneNascita": string;
    "ns2:pecCameraCommercio": string;
    "ns2:pecFiliale": string;
    "ns2:codiceAbi": string;
}

export const applicant_keys_PF: IObjectKey[] = [
    {
        label: 'NDG',
        key: 'ns2:ndg'
    },
    {
        label: 'Codice fiscale',
        key: 'ns2:codiceFiscale'
    },
    {
        label: 'Data di nascita',
        key: 'ns2:dataNascita',
        pipe: {
            key: 'date',
            value: null
        }
    },
    {
        label: 'Tipologia',
        key: 'ns2:naturaGiuridica'
    }
];

export const DOC_EXPIRED_MESSAGE: string = 'Attenzione! Il documento del soggetto selezionato è scaduto';